export default __webpack_public_path__ + "static/media/IMG_9906.ab7513b0.jpg";